import { IPage, ITitlePage } from '../../interfaces';
import {
    setEsNotificationsForcedUpdateTime,
    setEsNotificationsLogsForcedUpdateTime,
    setEsNotificationsQrcodesForcedUpdateTime,
    setForcedFilesListUpdateTime,
    setForcedResponsesListUpdateTime,
    setOperatorsForcedUpdateTime,
    setRatesForcedImportUpdateTime,
    setSubscribersForcedUpdateTime,
    setUsersForcedUpdateTime,
} from '../../middleware';

export const supportPages: IPage[] = [
    {
        id: '0000.01-Support-Pages',
        componentName: 'SupportPage',
        title: 'Support Pages',
        url: '/support-page',
        isActive: true,
        isDefault: false,
        isMenu: false,
        menuIcon: 'CustomerServiceOutlined',
        roleRight: ['ROOT'],
        roleAndFlagOperator: 'OR',
        featureFlag: ['allowImpersonate', 'allowOperatorInteractions'],
        subMenu: [
            {
                id: '0004-Support-page-upload-card-device',
                componentName: 'UploadCardDevice',
                title: 'Upload Card Device',
                url: '/support-page/upload-card-device',
                isActive: true,
                isMenu: false,
                menuIcon: 'UploadOutlined',
                roleRight: ['ROOT'],
            },
            {
                id: '0004-Support-page-hash-companies-info',
                componentName: 'HashCompaniesInfo',
                title: 'Hash Companies Info',
                url: '/support-page/hash-companies-info',
                isActive: true,
                isMenu: false,
                menuIcon: 'NumberOutlined',
                roleRight: ['ROOT'],
            },
            {
                id: '0004-Support-feature-flag-list',
                componentName: 'FeatureFlags',
                title: 'Feature Flags',
                url: '/support-page/feature-flags',
                isActive: true,
                isMenu: false,
                menuIcon: 'FlagOutlined',
                roleRight: ['ROOT'],
                subMenu: [
                    {
                        id: '0004-Support-feature-flag-list',
                        componentName: 'FeatureFlagsEdit',
                        title: 'Feature Flags Edit',
                        url: '/support-page/feature-flags/:id/edit',
                        isActive: true,
                        isMenu: false,
                        menuIcon: 'NumberOutlined',
                        roleRight: ['ROOT'],
                    },
                ],
            },
            {
                id: '0004-Support-gateway-config-list',
                componentName: 'GatewayConfig',
                title: 'Gateway Config',
                url: '/support-page/gateway-config',
                isActive: true,
                isMenu: false,
                menuIcon: 'GatewayOutlined',
                roleRight: ['ROOT'],
                subMenu: [
                    // {
                    //     id: '0004-Support-feature-flag-list',
                    //     componentName: 'FeatureFlagsEdit',
                    //     title: 'Feature Flags Edit',
                    //     url: '/support-page/feature-flags/:id/edit',
                    //     isActive: true,
                    //     isMenu: false,
                    //     menuIcon: 'NumberOutlined',
                    //     roleRight: ['ROOT'],
                    // },
                ],
                forcedUpdate: setOperatorsForcedUpdateTime,
            },
            {
                id: '0004-Support-scp-file-upload',
                componentName: 'ScpFileUpload',
                title: 'Scp File Upload',
                url: '/support-page/scp-file-upload',
                isActive: true,
                isMenu: false,
                menuIcon: 'FileAddOutlined',
                roleRight: ['ROOT'],
                subMenu: [
                    // {
                    //     id: '0004-Support-feature-flag-list',
                    //     componentName: 'FeatureFlagsEdit',
                    //     title: 'Feature Flags Edit',
                    //     url: '/support-page/feature-flags/:id/edit',
                    //     isActive: true,
                    //     isMenu: false,
                    //     menuIcon: 'NumberOutlined',
                    //     roleRight: ['ROOT'],
                    // },
                ],
                forcedUpdate: setOperatorsForcedUpdateTime,
            },
            {
                id: '0004-Support-page-impersonate-user',
                componentName: 'ImpersonateUser',
                title: 'Impersonate User',
                url: '/support-page/impersonate-user',
                isActive: true,
                isMenu: false,
                menuIcon: 'UserSwitchOutlined',
                featureFlag: ['allowImpersonate'],
                forcedUpdate: setUsersForcedUpdateTime,
            },
            {
                id: '0004-Support-page-External-API-List',
                componentName: 'ExternalAPIList',
                title: 'External API List',
                url: '/support-page/external-api',
                isActive: true,
                isMenu: false,
                menuIcon: 'ApiOutlined',
                roleRight: ['ROOT'],
                forcedUpdate: setSubscribersForcedUpdateTime,
            },
            {
                id: '0004-Support-page-ES-Plus-Notifications-List',
                componentName: 'ESPlusNotifications',
                title: 'ES2+ Notifications',
                url: '/support-page/notifications',
                isActive: true,
                isMenu: false,
                menuIcon: 'NotificationOutlined',
                roleRight: ['ROOT'],
                forcedUpdate: setEsNotificationsForcedUpdateTime,
            },
            {
                id: '0004-Support-page-ES-Plus-Notifications-Logs-List',
                componentName: 'ESPlusNotificationsLogs',
                title: 'ES2+ Logs Notifications Logs',
                url: '/support-page/notifications-logs',
                isActive: true,
                isMenu: false,
                menuIcon: 'NotificationOutlined',
                roleRight: ['ROOT'],
                forcedUpdate: setEsNotificationsLogsForcedUpdateTime,
            },
            {
                id: '0004-Support-page-ES-Plus-Notifications-QR-Codes-List',
                componentName: 'ESPlusNotificationQRcodes',
                title: 'ES2+ Logs Notification QR-codes',
                url: '/support-page/notifications-qrcodes',
                isActive: true,
                isMenu: false,
                menuIcon: 'NotificationOutlined',
                roleRight: ['ROOT'],
                forcedUpdate: setEsNotificationsQrcodesForcedUpdateTime,
            },
            {
                id: '0004-Support-page-External-API',
                componentName: 'ExternalAPIEdit',
                title: 'External API' as ITitlePage,
                url: '/support-page/external-api/:id',
                isActive: true,
                isDefault: false,
                menuIcon: 'EyeOutlined',
            },
            {
                id: '0004-Support-page-operator-interactions-files-List',
                componentName: 'OperatorInteractionsFilesList',
                title: 'Operator Interactions Files List',
                url: '/operator_interactions/files',
                isActive: true,
                isMenu: false,
                menuIcon: 'FileExcelOutlined',
                featureFlag: ['allowOperatorInteractions'],
                forcedUpdate: setForcedFilesListUpdateTime,
            },
            {
                id: '0004-Support-page-operator-interactions-responses-List',
                componentName: 'OperatorInteractionsResponsesList',
                title: 'Operator Interactions Responses List',
                url: '/operator_interactions/responses',
                isActive: true,
                isMenu: false,
                menuIcon: 'ApiOutlined',
                featureFlag: ['allowOperatorInteractions'],
                forcedUpdate: setForcedResponsesListUpdateTime,
            },
            {
                id: '0004-Support-page-operator-interactions-responses',
                componentName: 'OperatorInteractionsResponse',
                title: 'Operator Interactions Response',
                url: '/operator_interactions/responses/:id',
                isActive: true,
                isDefault: false,
                featureFlag: ['allowOperatorInteractions'],
                menuIcon: 'EyeOutlined',
            },
            {
                id: '0004-Support-page-srl-import',
                componentName: 'DataImport',
                title: 'Data Import',
                url: '/support-page/data-import',
                isActive: true,
                isMenu: false,
                menuIcon: 'ImportOutlined',
                roleRight: ['ROOT'],
                roleAndFlagOperator: 'OR',
                featureFlag: ['allowImpersonate', 'allowOperatorInteractions'],
                forcedUpdate: setRatesForcedImportUpdateTime,
            },
            {
                id: '0004-Support-page-companies-hierarchy-v2',
                componentName: 'CompaniesHierarchyV2',
                title: 'Companies Hierarchy v2',
                url: '/support-page/companies-hierarchy-v2',
                isActive: true,
            },
            {
                id: '0004-Support-page-card-set-hierarchy',
                componentName: 'CardSetHierarchy',
                title: 'Card Set Hierarchy',
                url: '/support-page/card-set-hierarchy',
                isActive: true,
            },
        ],
    },
];
